/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import Draggable from 'react-draggable';
import { Breakpoint } from 'react-socks';

class ConfirmModal extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            processing: false
        };

        this.confirmClick = this.confirmClick.bind(this);

        this.draggableRef = React.createRef();

    }

    componentDidMount() {

		window.location.hash = "confirm";

    }

    componentDidUpdate(prevProps, prevState) {
        // apparently react will reuse a component but pass it new props.
        // cool except for the processing state not being reset so do that if the
        // component notices the copy has changed
        if (prevProps.modalCopy !== this.props.modalCopy) {
            this.setState({
                processing: false
            });
        }

        // catch the back button
        if (this.props.showCancel && window.location.hash !== "#confirm") {
			this.props.cancelAction();
		}
    }

    componentWillUnmount() {
        if (window.location.hash.match("#confirm")) {
			let cleanUrl = window.location.href.substring(0, window.location.href.indexOf("#"));
            window.history.replaceState({}, '', cleanUrl);
		}
    }

    confirmClick(e) {

        this.props.confirmAction(e);

        if (this.props.showProcessing) {
            this.setState({
                processing: true
            });
        }

    }

    render() {
        let cancelButton = null,
            { confirmDataset } = this.props,
            confirmLabel = this.props.confirmLabel;

        if (this.props.showCancel === true) {
            cancelButton = (
                <div className="action-cancel" onClick={this.props.cancelAction} role="button" aria-label={this.props.cancelLabel}>
                    {this.props.cancelLabel}
                </div>
            );
        }

        if (this.state.processing) {
            confirmLabel = (
                <span>
                    <i className="fa fa-spinner fa-spin"></i>
                </span>
            );
        }

        return (
            <div className="dlvr-modal" role="dialog" aria-modal="true">
                <Breakpoint desktop only>
    				<Draggable nodeRef={this.draggableRef} handle=".dlvr-delete-modal" cancel=".action-cancel, .dlvr-delete-close, .action-confirm">
    					<div ref={this.draggableRef} className="dlvr-delete-modal">
                            <div className="dlvr-delete-close" onClick={this.props.closeAction || this.props.cancelAction} role="button" aria-label="close dialog">
                                <i className="fa fa-times"></i>
                            </div>
                            <div className="dlvr-delete-copy">
                                {this.props.modalCopy}
                            </div>
                            <div className="dlvr-delete-actions">
                                {cancelButton}
                                <button className="btn-confirm action-confirm" {...confirmDataset} onClick={this.confirmClick}>
                                    {confirmLabel}
                                </button>
                            </div>
    					</div>
    				</Draggable>
                </Breakpoint>
                <Breakpoint mobile only>
					<div className="dlvr-delete-modal">
                        <div className="dlvr-delete-close" onClick={this.props.closeAction || this.props.cancelAction} role="button" aria-label="close dialog">
                            <i className="fa fa-times"></i>
                        </div>
                        <div className="dlvr-delete-copy">
                            {this.props.modalCopy}
                        </div>
                        <div className="dlvr-delete-actions">
                            {cancelButton}
                            <button className="btn-confirm action-confirm" {...confirmDataset} onClick={this.confirmClick}>
                                {confirmLabel}
                            </button>
                        </div>
					</div>
                </Breakpoint>
			</div>
        );
    }

};

ConfirmModal.propTypes = {
    modalCopy: PropTypes.string,
    cancelAction: PropTypes.func,
    confirmAction: PropTypes.func,
    context: PropTypes.string
};

ConfirmModal.defaultProps = {
    modalCopy: '',
    cancelAction: null,
    confirmAction: null,
    closeAction: null,
    confirmLabel: 'Yes',
    cancelLabel: 'No',
    context: 'default',
    showCancel: true,
    showProcessing: true
};

export default ConfirmModal;
